<template>
  <div class="container">
    <div v-if="current">
      <h1 class="title">{{ current.title }}</h1>
      <h2 class="subtitle">{{ current.description }}</h2>

      <div class="box">
        <div class="columns is-multiline">
          <div
            v-for="input in current.filterOptions"
            :key="input.property"
            class="column"
          >
            <b-field :label="input.name">
              <b-datepicker
                v-if="input.typeName === 'DateTimeFilter'"
                :show-week-number="true"
                placeholder="Bitte wählen."
                icon="calendar"
                trap-focus
                v-model="request[input.property]"
              >
              </b-datepicker>
              <b-input
                v-if="input.typeName === 'TextFilter'"
                placeholder="Suche..."
                icon="search"
                v-model="request[input.property]"
              >
              </b-input>
            </b-field>
          </div>

          <div class="column has-text-right">
            <div class="button is-primary" v-on:click="query()">
              Abfragen
            </div>
          </div>
        </div>
      </div>

      <nav class="level is-mobile">
        <div class="level-left"></div>
        <div class="level-right">
          <b-button
            class="level-item"
            aria-label="Aktualisieren"
            v-on:click="query()"
            type="is-dark"
            icon-left="sync"
          >
          </b-button>
          <b-button
            aria-label="Exportieren"
            v-on:click="exportCurrentData()"
            icon-left="file-download"
            type="is-dark"
          >
            .csv
          </b-button>
        </div>
      </nav>
      <div class="box table-container">
        <table class="table is-striped is-narrow is-hoverable is-fullwidth">
          <thead>
            <tr>
              <td v-for="td in current.columns" :key="td.property">
                {{ td.title }}
              </td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, i) in result.results" :key="i">
              <td v-for="td in current.columns" :key="td.property">
                <span v-if="td.formatter === 'date'">
                  {{ row[td.property] | formatDate }}
                </span>
                <span v-if="td.formatter === 'amount'">
                  {{ row[td.property] | amount }}
                </span>

                <span v-if="td.formatter === 'none'">
                  {{ row[td.property] }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <b-pagination
          @change="pageChanged"
          :total="result.total"
          :current.sync="result.page"
          :per-page="request.pageSize"
        >
        </b-pagination>
      </div>
    </div>
    <div v-if="!current">
      <div class="notification is-danger">
        Die angefragte Statistik Abfrage existiert nicht oder ist derzeit nicht
        aktiv.
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import statsApi from '@/api/statistics-api'
import csvConverter from '@/common/statistic-csv-converter'
export default {
  name: 'StatisticQuery',
  data() {
    return {
      current: null,
      request: {
        page: 1,
        pageSize: 12,
      },
      result: {
        total: 0,
        results: [],
      },
    }
  },
  computed: {
    ...mapGetters(['stats']),
  },
  mounted() {
    this.current = this.stats.find(
      f => f.queryID.toLowerCase() == this.$route.params.id,
    )
  },
  methods: {
    async pageChanged(page) {
      this.request.page = page
      await this.query()
    },
    async exportCurrentData() {
      if (this.result.total > 0) {
        this.$buefy.toast.open({
          duration: 5000,
          message: `Bereite Daten auf Export vor ...`,
          position: 'is-bottom',
          type: 'is-info',
        })
        let req = {...this.request}
        req.page = 1
        req.pageSize = this.result.total
        try {
          const exportData = await statsApi.queryById(this.current.queryID, req)
          let csvContent = csvConverter.exportAsCsv(
            this.current.columns,
            exportData.results,
          )
          csvConverter.downloadCsvData(
            csvContent,
            this.current.queryID.toLowerCase(),
          )
        } catch {
          this.$buefy.toast.open({
            duration: 5000,
            message: `Die Abfrage konnte leider nicht verarbeitet weren, versuchen Sie es bitte erneut.`,
            position: 'is-bottom',
            type: 'is-danger',
          })
        }
      } else {
        this.$buefy.toast.open({
          duration: 5000,
          message: `0 Datensätze zum Exportieren.`,
          position: 'is-bottom',
          type: 'is-danger',
        })
      }
    },
    async query() {
      try {
        this.result = await statsApi.queryById(
          this.current.queryID,
          this.request,
        )
      } catch {
        this.current = null
      }
    },
  },
}
</script>
